// extracted by mini-css-extract-plugin
export default {"lineSlotContainer":"iP5ME","slotName":"LsDtC","slotStakes":"gTnfl","matchesSlotName":"P6kee","outrightMatch":"hLZcv","disabledIcon":"ti9ie"};